module.exports = __webpack_public_path__ + "img/12.50cb3d90.jpg";